// extracted by mini-css-extract-plugin
export default {"container":"ID2Pm1","is-inline":"tDB6BP","date-part":"rnn3NY"};